import { resetErrorStatus } from "@modules/global";
import { useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Box, Button, Card, CardContent, Alert, Grid } from "@mzc-pdc/ui";
import { IconForward, ImageAccessNot, ImageNoAccessInfo } from "@mzc-cloudplex/icons";
import Typography from "@components_v2/typography/typography";
import theme from "@styles/theme";
import { alpha } from "@mui/material";
import { siteMode } from "@cores/siteMode";
import menuService from "@services/menuService";

const AccessDenied = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isLibrary = siteMode.get() === "CMS";

    useEffect(() => {
        return () => {
            dispatch(resetErrorStatus());
        };
    }, [dispatch]);

    const handleGoToHome = useCallback(() => {
        window.location.href = isLibrary ? menuService.paths.library.spaces() : menuService.paths.spaces();
    }, []);

    return (
        <Grid container sx={{ justifyContent: "center", alignItems: "center", height: "100%" }}>
            <Card
                sx={{
                    width: 600,
                    textAlign: "center",
                    border: `1px solid ${theme.palette.greySecondary[100]}`,
                    backgroundColor: theme.palette.background.paper,
                }}
            >
                <CardContent sx={{ padding: 4 }}>
                    {/* 에러 아이콘 */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: 3,
                        }}
                    >
                        <ImageNoAccessInfo width={60} height={60} />
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: theme.spacing(1.5),
                            my: theme.spacing(4),
                        }}
                    >
                        <Typography variant="h3" gutterBottom color={theme.palette.greySecondary.main}>
                            {t(`common::msg::You don't have permission to view this page.`)}
                        </Typography>

                        <Typography variant={"body1_700"} gutterBottom color={theme.palette.greySecondary[600]}>
                            {t(`common::msg::Go to the start page and select a project you have access to.`)}
                        </Typography>
                    </Box>

                    {/* 버튼 */}
                    <Button
                        variant="contained"
                        color={"primary"}
                        size="medium"
                        endIcon={<IconForward size={20} />}
                        onClick={handleGoToHome}
                        sx={{
                            paddingX: 4,
                            paddingY: 1.5,
                            borderRadius: 2,
                            textTransform: "none",
                            fontSize: "1rem",
                            mb: theme.spacing(6),
                        }}
                    >
                        {t(`common::label::To Start Page`)}
                    </Button>
                    <Alert severity="info" sx={{ borderRadius: theme.spacing(0.5) }}>
                        <Typography variant="body1_400" color={theme.palette.greySecondary.main}>
                            {t(
                                `common::msg::${"If you don’t have access to any projects, please contact your administrator."}`,
                            )}
                        </Typography>
                    </Alert>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default AccessDenied;
